import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
//primereact
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
//utils
import { queryClient } from "../../../../../../../utils/queryClient";
//components
import Modal from "../../../../../../../components/modal/Modal";
import Input from "../../../../../../../components/input/Input";
import Select from "../../../../../../../components/input/Select";
import TextareaInput from "../../../../../../../components/input/TextareaInput";
//services
import { putOccurence } from "../../../../../../../services/Contracts/putOccurence";

const ModalEdit = ({ id, showModal, setShowModal, defaultValuesModal }) => {
  const form = useForm();
  const errors = form.formState.errors;

  const [loadingButton, setLoadingButton] = useState();

  const handleEdit = async (data) => {
    data.sale_id = id;
    data.id = defaultValuesModal.id;
    setLoadingButton(true);
    const notification = toast.loading("Por favor aguarde...");
    try {
      await putOccurenceFn(data);
      toast.update(notification, {
        render: "Ocorrência Editada com Sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoadingButton(false);
    } catch (error) {
      toast.update(notification, {
        render: error.message,
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
      return;
    }
    setShowModal(false);
  };

  const { mutateAsync: putOccurenceFn } = useMutation({
    mutationFn: putOccurence,
    onSuccess(_, variables) {
      queryClient.setQueryData([`occurences${id}`], (data) => {
        const updatedData = [...data];
        const index = updatedData.findIndex((i) => i.id === variables.id);
        if (index !== -1) {
          updatedData[index].status = variables.status;
          updatedData[index].title = variables.title;
          updatedData[index].description = variables.description;
        }
        return updatedData;
      });
    },
    onError(error) {
//      console.log(error);
    },
  });

  const optionsStatus = [
    {
      label: "Em andamento",
      value: 0,
    },
    {
      label: "Finalizada",
      value: 1,
    },
  ];

  useEffect(() => {
    if (defaultValuesModal) {
      form.setValue("title", defaultValuesModal.title);
      form.setValue("description", defaultValuesModal.description);
      form.setValue("status", defaultValuesModal.status);
    }
  }, [defaultValuesModal, form]);

  return (
    <Modal
      visible={showModal}
      position="center"
      onHide={() => setShowModal(false)}
      dynamicTitle="Resumo da Cessão"
    >
      <form onSubmit={form.handleSubmit(handleEdit)}>
        <div className="row mb-2">
          <div className="col-md-8">
            <Input
              name="title"
              errors={errors}
              control={form.control}
              label={`Título`}
            />
          </div>
          <div className="col-md-4">
            <Select
              name="status"
              label="Status da Ocorrência"
              errors={errors}
              control={form.control}
              options={optionsStatus}
            />
          </div>
        </div>
        <TextareaInput
          name="description"
          label="Descrição"
          errors={errors}
          control={form.control}
        />
        <div className="row mt-4 d-flex justify-content-end">
          <div className="col-md-8 text-end">
            <Button
              type="submit"
              label="Finalizar Edição"
              className="bg-success w-50"
              icon="fa-solid fa-check"
              loading={loadingButton}
              rounded
            />
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default ModalEdit;
